import _extends from "babel-runtime/helpers/extends";
import _taggedTemplateLiteralLoose from "babel-runtime/helpers/taggedTemplateLiteralLoose";

var _soundBarSize;

var _templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: .35;\n    height: 3px;\n  }\n  100% {\n    opacity: 1;\n    height: 28px;\n  }\n"], ["\n  0% {\n    opacity: .35;\n    height: 3px;\n  }\n  100% {\n    opacity: 1;\n    height: 28px;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: .35;\n    height: ", "px;\n    bottom: ", "px;\n  }\n  100% {\n    opacity: 1;\n    height: ", "px;\n    bottom: ", "px;\n  }\n"], ["\n  0% {\n    opacity: .35;\n    height: ", "px;\n    bottom: ", "px;\n  }\n  100% {\n    opacity: 1;\n    height: ", "px;\n    bottom: ", "px;\n  }\n"]);

import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/core";

var ACTIVE_SILENT = "ACTIVE_SILENT";
var ACTIVE_SOFT = "ACTIVE_SOFT";
var ACTIVE_NORMAL = "ACTIVE_NORMAL";
var ACTIVE_LOUD = "ACTIVE_LOUD";

var getActiveSoundWaveState = function getActiveSoundWaveState(soundLevelInt) {
  var soundWaveState = ACTIVE_SILENT; // default to be overridden by case statement
  switch (soundLevelInt) {
    case 0:
      soundWaveState = ACTIVE_SILENT;
      break;
    case 1:
      soundWaveState = ACTIVE_SOFT;
      break;
    case 2:
      soundWaveState = ACTIVE_SOFT;
      break;
    case 3:
      soundWaveState = ACTIVE_NORMAL;
      break;
    case 4:
      soundWaveState = ACTIVE_NORMAL;
      break;
    case 5:
      soundWaveState = ACTIVE_NORMAL;
      break;
    case 6:
      soundWaveState = ACTIVE_LOUD;
      break;
    case 7:
      soundWaveState = ACTIVE_LOUD;
      break;
    case 8:
      soundWaveState = ACTIVE_LOUD;
      break;
    case 9:
      soundWaveState = ACTIVE_LOUD;
      break;
    case 10:
      soundWaveState = ACTIVE_LOUD;
      break;
    default:
      soundWaveState = ACTIVE_SILENT;
  }
  return soundWaveState;
};

var SoundWaveWrapperWrapperDiv = styled.div({
  height: 30,
  width: 60,
  borderRadius: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

var SoundWaveWrapperDiv = styled.div({
  height: 28,
  position: "absolute",
  width: 40
});

var sound = keyframes(_templateObject);

var soundBarKeyFrames = function soundBarKeyFrames(_ref) {
  var initialHeight = _ref.initialHeight,
      initialBottom = _ref.initialBottom,
      finalHeight = _ref.finalHeight,
      finalBottom = _ref.finalBottom;
  return keyframes(_templateObject2, initialHeight, initialBottom, finalHeight, finalBottom);
};

var leftValueByBar = {
  1: 3,
  2: 10,
  3: 17,
  4: 24,
  5: 31
};

var animationDurationByBarNumber = {
  1: 374,
  2: 333,
  3: 307,
  4: 358,
  5: 300
};

var extraSmallBar = { initialHeight: 3, initialBottom: 13, finalHeight: 10, finalBottom: 10 };
var smallBar = { initialHeight: 3, initialBottom: 13, finalHeight: 12, finalBottom: 9 };
var mediumBar = { initialHeight: 3, initialBottom: 13, finalHeight: 20, finalBottom: 5 };
// const largeBar = {};

var soundBarSize = (_soundBarSize = {}, _soundBarSize["" + ACTIVE_SOFT] = {
  1: _extends({}, extraSmallBar),
  2: _extends({}, smallBar),
  3: _extends({}, extraSmallBar),
  4: _extends({}, smallBar),
  5: _extends({}, extraSmallBar)
}, _soundBarSize["" + ACTIVE_NORMAL] = {
  1: _extends({}, smallBar),
  2: _extends({}, mediumBar),
  3: _extends({}, smallBar),
  4: _extends({}, mediumBar),
  5: _extends({}, smallBar)
}, _soundBarSize["" + ACTIVE_LOUD] = {
  1: _extends({}, mediumBar),
  2: _extends({}, mediumBar),
  3: _extends({}, mediumBar),
  4: _extends({}, mediumBar),
  5: _extends({}, mediumBar)
}, _soundBarSize);

var Bar = styled.div(function (_ref2) {
  var number = _ref2.number,
      activeSoundWaveState = _ref2.activeSoundWaveState;

  var styles = {
    // common
    background: "#9ED16B",
    position: "absolute",
    borderRadius: 3,
    width: 6,
    // will vary by bar
    bottom: 1,
    height: 3,
    // may end up overriding all of them
    animation: sound + " 0ms -800ms linear infinite alternate"
  };

  /*
    all sound waves for SILENT STATE
  */
  if (activeSoundWaveState === ACTIVE_SILENT) {
    var height = 5;
    var bottom = 11;
    styles.height = height;
    styles.bottom = bottom;
    // static:
    styles.left = leftValueByBar[number];
    styles.animationDuration = animationDurationByBarNumber[number] + "ms";
    styles.animation = soundBarKeyFrames({
      initialHeight: height,
      initialBottom: bottom,
      finalHeight: height,
      finalBottom: bottom
    }) + " 0ms -800ms linear infinite alternate";
    return styles;
  }

  styles.height = soundBarSize[activeSoundWaveState][number].initialHeight;
  styles.bottom = soundBarSize[activeSoundWaveState][number].initialBottom;
  // static:
  styles.left = leftValueByBar[number];
  styles.animationDuration = animationDurationByBarNumber[number] + "ms";
  styles.animation = soundBarKeyFrames({
    initialHeight: soundBarSize[activeSoundWaveState][number].initialHeight,
    initialBottom: soundBarSize[activeSoundWaveState][number].initialBottom,
    finalHeight: soundBarSize[activeSoundWaveState][number].finalHeight,
    finalBottom: soundBarSize[activeSoundWaveState][number].finalBottom
  }) + " 0ms -800ms linear infinite alternate";

  return styles;
});

function normalizeNumber(soundLevel) {
  return Math.round(soundLevel * 10);
}

function energyToSoundWaveState(energy) {
  return getActiveSoundWaveState(normalizeNumber(energy));
}

function isSameValue(prevProps, nextProps) {
  return energyToSoundWaveState(prevProps.soundLevel) === energyToSoundWaveState(nextProps.soundLevel);
}

var SoundWaveVolume = React.memo(function (props) {
  var activeSoundWaveState = props.hardCodedSoundWaveState || energyToSoundWaveState(props.soundLevel);

  return React.createElement(
    SoundWaveWrapperWrapperDiv,
    { "data-qa": "SoundWaveMicVolumeIcon-" + activeSoundWaveState },
    React.createElement(
      SoundWaveWrapperDiv,
      null,
      React.createElement(Bar, { number: 1, activeSoundWaveState: activeSoundWaveState }),
      React.createElement(Bar, { number: 2, activeSoundWaveState: activeSoundWaveState }),
      React.createElement(Bar, { number: 3, activeSoundWaveState: activeSoundWaveState }),
      React.createElement(Bar, { number: 4, activeSoundWaveState: activeSoundWaveState }),
      React.createElement(Bar, { number: 5, activeSoundWaveState: activeSoundWaveState })
    )
  );
}, isSameValue);

export default SoundWaveVolume;